import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { PromotionReplyApi } from 'api/ApiHelper';

export const useUnLikePromotionReplyMutation = (promotionId: number, replyId: string, options: UseMutationOptions) =>
  useMutation({
    mutationFn: () => PromotionReplyApi.unlikePromotionReply(promotionId, replyId),
    ...options,
  });
